const FOLLOWS_KEY = "shialoc_guest_follows";
const prefsKey = (slug) => `shialoc_guest_prefs_${slug}`;

const read = (key, fallback) => {
  try { return JSON.parse(localStorage.getItem(key)) ?? fallback; } catch { return fallback; }
};

export const getGuestFollows = () => read(FOLLOWS_KEY, []);

export const isGuestFollowing = (slug) => getGuestFollows().includes(slug);

export const toggleGuestFollow = (slug) => {
  const follows = getGuestFollows();
  const next = follows.includes(slug) ? follows.filter((s) => s !== slug) : [...follows, slug];
  localStorage.setItem(FOLLOWS_KEY, JSON.stringify(next));
  return next.includes(slug);
};

export const getGuestPrefs = (slug) => read(prefsKey(slug), {});

export const setGuestPrefs = (slug, prefs) => {
  localStorage.setItem(prefsKey(slug), JSON.stringify({ ...getGuestPrefs(slug), ...prefs }));
};
